import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainLayoutComponentComponent } from "./main-layout-component/main-layout-component.component";
import { ProductsComponent } from "./products/products.component";
import { ConfirmationComponent } from "./confirmation/confirmation.component";
import { ErrorComponent } from "./error/error.component";
import { PaymentComponent } from "./payment/payment.component";
import { QrcodeComponent } from "./qrcode/qrcode.component";

const routes: Routes = [
  {
    path: "",
    component: MainLayoutComponentComponent,
    children: [
      { path: "", component: ProductsComponent },
      { path: "qrcode", component: QrcodeComponent },
      { path: "payment", component: PaymentComponent },
      { path: "confirmation", component: ConfirmationComponent },
      { path: "error", component: ErrorComponent },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { enableTracing: false, useHash: true, anchorScrolling: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
